export default (hours) => {
  const [integer, rest] = String(hours.toFixed(2)).split('.')
  let newHours = integer

  if (rest === '00') {
    newHours += '.00'
  } else if (rest <= 25) {
    newHours += '.25'
  } else if (rest <= 50) {
    newHours += '.50'
  } else if (rest <= 75) {
    newHours += '.75'
  } else {
    newHours = `${+newHours + 1}.00`
  }

  return newHours
}
